import { styled } from '../../../base-components';

export const TopActionsContainer = styled('div')<{
    height: number | undefined;
    isSticky: boolean;
}>(({ theme, height: height, isSticky }) => {
    return {
        flex: 1,
        height: height ? `${height}px` : undefined,
        position: isSticky ? 'sticky' : undefined,
        top: isSticky ? 0 : undefined,
        left: isSticky ? 0 : undefined,
        backgroundColor: theme.palette.common.white,
        zIndex: isSticky ? 2 : undefined,
        borderTopRightRadius: theme.spacing(1),
        borderTopLeftRadius: theme.spacing(1),
    };
});
